import { useState } from "react";
import useDialog from "../../../../hooks/useDialog";

/**
 * 販売原票一括入力　検索条件管理hook
 */
export const useQrPreviewDialog = () => {
  const dialog = useDialog();
  const [pdfUrl, setPdfUrl] = useState(null);

  return { 
    isOpen: dialog.isOpen,
    open: dialog.open,
    close: dialog.onClose(null),
    pdfUrl,
    setPdfUrl
  };
  
}


